export const pctValueFormatter = (v: number) => {
    try {
        return `${v.toFixed(1)}%`;
    } catch (err) {
        debugger
        return 'N/A';
    }
};
export const pctValueSignFormatter = (v: number) => {
    try {
        return `${v > 0 ? '+' : ''}${v.toFixed(1)}%`;
    } catch (err) {
        return 'N/A';
    }
};